<template>
  <Grid />
</template>
<script>
import Grid from './components/grid'
export default {
  name: 'quality-inspection-aql',
  components: { Grid },
}
</script>
